import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import { fetchTemplate } from 'store/actions/templates';
import { templatesSelectors } from 'store/selectors/templates';

import Grid from 'material/components/Grid';

import { Backdrop, BreadcrumbsNavigation, Container } from 'common/components';
import TopCard from 'common/containers/TopCard';
import { CardWrapper } from 'globalStyles';

const TemplateDetails = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { organizationUuid, templateUuid } = useParams();

  const [templateData, setTemplateData] = useState({});

  const { isFetching } = useSelector(state => ({
    isFetching: templatesSelectors.isFetching(state),
  }));

  const breadcrumbs = [
    {
      link:
        templateData?.type === 'broadcast'
          ? `/${organizationUuid}/broadcasts`
          : `/${organizationUuid}/campaigns`,
      name: templateData?.type === 'broadcast' ? 'Broadcasts' : 'Advocacy',
    },
    {
      link: `/${organizationUuid}/templates/${templateData?.type === 'broadcast' ? 'broadcast' : 'action_alert'}`,
      name: 'Email Templates',
    },
    {
      link: '',
      name: templateData.name,
    },
  ];

  useEffect(() => {
    dispatch(fetchTemplate(templateUuid)).then(data => setTemplateData(data));
  }, []);

  return (
    <>
      <BreadcrumbsNavigation isLoading={isFetching} links={breadcrumbs} />
      <Container>
        <Grid container>
          <TopCard
            title={templateData.name}
            backButtonLink={`/${organizationUuid}/templates/${templateData?.type}`}
            actionButtons={[
              {
                name: 'Edit',
                onClick: () =>
                  history.push(
                    `/${organizationUuid}/create-template/${templateData.type}/${templateUuid}`
                  ),
                variant: 'outlined',
              },
            ]}
          />
        </Grid>
        {templateData.message && (
          <CardWrapper>
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: templateData.message.replace(/<style[\s\S]*?<\/style>/gi, ''),
              }}
            />
          </CardWrapper>
        )}
      </Container>
      <Backdrop isOpen={isFetching} />
    </>
  );
};

export default TemplateDetails;
